import {
  getStorage as getFirebaseStorage,
  ref,
  deleteObject,
} from 'firebase/storage';
import { firebaseApp } from './init';
import { UnifiedUploader } from '@/lib/unifiedUpload';
import { getAuth } from 'firebase/auth';

export const firebaseStorage = getFirebaseStorage(firebaseApp);

// Updated to use AWS S3 instead of Firebase Storage
export const uploadFile = async (path: string, file: Blob): Promise<string> => {
  if (!path) {
    throw new Error('Path is required for file upload');
  }

  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      throw new Error('No authenticated user found');
    }
    // Convert Blob to File if needed
    const fileToUpload = file instanceof File ? file : new File([file], 'uploaded-file', { type: file.type });

    // Upload to S3 instead of Firebase Storage
    const s3Url = await UnifiedUploader.uploadFile(fileToUpload, currentUser.uid, 'temp', undefined, path);
    console.log('File uploaded to S3:', s3Url?.url);
    return s3Url?.url;
  } catch (error) {
    console.error('❌ Error uploading file to S3:', error);
    throw error;
  }
};

// Delete file from Firebase Storage (for legacy files)
export const deleteFileFromFirebase = async (filePath: string): Promise<void> => {
  if (!filePath) {
    throw new Error('File path is required for deletion');
  }

  try {
    console.log('🗑️ Deleting file from Firebase Storage:', filePath);

    // Create a reference to the file
    const fileRef = ref(firebaseStorage, filePath);

    // Delete the file
    await deleteObject(fileRef);

    console.log('✅ File deleted from Firebase Storage successfully');
  } catch (error) {
    console.error('❌ Error deleting file from Firebase Storage:', error);
    throw error;
  }
};

// Extract Firebase Storage path from URL
export const extractFirebasePathFromUrl = (url: string): string | null => {
  try {
    if (!url || typeof url !== 'string') {
      return null;
    }

    // Handle Firebase Storage URLs
    if (url.includes('firebasestorage.googleapis.com')) {
      // Extract path from Firebase Storage URL
      // Format: https://firebasestorage.googleapis.com/v0/b/bucket-name/o/path%2Fto%2Ffile?alt=media
      const firebasePath = url.split('/o/')[1]?.split('?')[0];
      if (firebasePath) {
        return decodeURIComponent(firebasePath);
      }
    }

    return null;
  } catch (error) {
    console.error('❌ Error extracting Firebase path from URL:', error);
    return null;
  }
};
